import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IsomastersButtonComponent } from './isomasters-button/isomasters-button.component';
import { IsomastersSliderComponent } from './isomasters-slider/isomasters-slider.component';
import { IsomastersInputComponent } from './isomasters-input/isomasters-input.component';
import { IsomastersHorizontalViewboxComponent } from './isomasters-horizontal-viewbox/isomasters-horizontal-viewbox.component';
import { IsomastersScrollbarComponent } from './isomasters-scrollbar/isomasters-scrollbar.component';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { IsomastersPopupComponent } from './isomasters-popup/isomasters-popup.component';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { IsomastersPagingComponent } from './isomasters-paging/isomasters-paging.component';
import { PlusMinPricePipeModule } from '../pipes/plus-min-price-pipe.module';
import { IsomastersTextCopyComponent } from './isomasters-text-copy/isomasters-text-copy.component';
import { ClipboardModule } from '@angular/cdk/clipboard';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    IsomastersButtonComponent,
    IsomastersSliderComponent,
    IsomastersInputComponent,
    IsomastersHorizontalViewboxComponent,
    IsomastersScrollbarComponent,
    IsomastersPopupComponent,
    IsomastersPagingComponent,
    IsomastersTextCopyComponent,
  ],
  imports: [CommonModule, TranslateModule.forChild(), InlineSVGModule, PlusMinPricePipeModule, ClipboardModule],
  exports: [
    IsomastersButtonComponent,
    IsomastersSliderComponent,
    IsomastersInputComponent,
    IsomastersHorizontalViewboxComponent,
    IsomastersScrollbarComponent,
    IsomastersPopupComponent,
    IsomastersTextCopyComponent,
  ],
})
export class IsomastersUiModule {}
